module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_12.7b5a6e72.jpeg";